<template>
    <v-container fluid >
        <div v-if="!fetchLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t("stock_adjustment")}}</h4>
                    <p class="text-subtitle-1">{{$t("used_to_adjustment_stock")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <StockAdjustmentForm
                        v-model="data"
                        ref="form"
                        :warehouseId="warehouseId"
                    />
                </v-col>
            </v-row>
             <v-row class="my-2">
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        {{$t("save")}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" @click="onCancel">
                    <v-btn depressed block>
                        {{$t("cancel_btn")}}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
                <v-col md="3">
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import stockAdjustment from "./../../services/stockJournal/stockAdjustment"
import StockAdjustmentForm from './../../components/warehouse/StockAdjustmentForm.vue';
export default {
    components: {
        StockAdjustmentForm
    },
    data() {
        return {
            warehouseId: null,
            data: {},
            id: null,
            fetchLoading: false,
            loading: false,
            alert: {
                value: false,
                title: null,
                content: "Are you sure?",
                callback: null
            }

        }
    },
    methods: {
        fetch() {
            this.fetchLoading = true;
            stockAdjustment.get(this.id, this.warehouseId).then(res => {
                this.data = {
                    id: res.data.id,
                    date: res.data.date,
                    reference: res.data.reference,
                    remarks: res.data.remarks,
                    lines: res.data.lines.map(line => {
                        return {
                            item_id: line.item.id,
                            item: line.item,
                            quantity: line.quantity,
                            base_quantity: line.base_quantity,
                            measure_unit_id: line.measure_unit.id,
                            unit_value: line.value / line.quantity,
                            value: line.value,
                            account_id: line.account.id,
                            dimension_id: line.dimension.id,
                            key: Math.random()
                        }

                    })
                }
            }).finally(() => {
                this.fetchLoading = false
            })
        },
        onCancel() {
            this.$router.back()
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            stockAdjustment.update({...this.data, warehouse_id: this.warehouseId}).then((response) => {
               this.$router.replace({
                    name: "AdjustmentDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            });
        },

    },
    created() {    
        this.id = this.$route.params.id;    
        this.warehouseId = this.$route.params.warehouseId;
        this.fetch()
    }
}
</script>

<style>

</style>